export const SITE_WORKING_CONDITION_MODULATION_CARD_FRENCH_LOCALE = {
  title: "Modulations",
  lastSevenDays: "7 derniers jours",
  pilotPresentOnSite: "Pilote présent sur site: {yesno}",
};
